import React, { useEffect, useState } from "react";
import SidebarLayout from "../BankerUI/SidebarLayout";
import { Typography, Spin, message } from "antd";
import moment from "moment";
import _commonService from "../../modules/commonService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import ApplicationList from "../BankerUI/ApplicationList";
import { useLocation } from "react-router-dom";
import _LoanOfficerService from "../../modules/LoanOfficerService";

const { Title, Text } = Typography;

const LoanApplicationsForLoanOfficer = () => {
    const [loanApplications, setLoanApplications] = useState([]);
    const loanOfficerIdRaw = localStorage.getItem("LoanOfficerId");
    const LoanOfficerId = loanOfficerIdRaw ? parseInt(loanOfficerIdRaw) : null;
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [applicationStatus, setApplicationStatus] = useState();

    const location = useLocation();
    let data = location.state;
    let appStatusFlag = 0;
    if (data && data.applicationStatusFlag) {
        appStatusFlag = data.applicationStatusFlag;
    }

    const [applicationStatusFilter] = useState(appStatusFlag);

    useEffect(() => {
        setApplicationStatus(applicationStatusFilter);
    }, [applicationStatusFilter]);

    useEffect(() => {
        getAllLoanApplicationListByLoanOfficerId();
    }, [debouncedSearchText, applicationStatus, toDate, sortBy, pageIndex, pageSize]);


    useEffect(() => {
        if (debouncedSearchText !== "") {
            setPageIndex(1);
            setPageSize(10);
        }
    }, [debouncedSearchText]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchText(searchTerm && searchTerm.trim());
        }, 900);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const getAllLoanApplicationListByLoanOfficerId = async () => {
        if ((applicationStatus != undefined || applicationStatus == 0)) {
            const params = {
                loanOfficerId: LoanOfficerId,
                ByAppStatus: applicationStatus,
                startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
                endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
                pageIndex,
                pageSize,
                searchTerm: debouncedSearchText,
                sortBy,
                sortAsc: true,
            };
            setLoading(true);
            try {
                const resObj = await _LoanOfficerService.getAllLoanApplicationListByLoanOfficerId(params);

                if (
                    resObj?.data?.IsSuccess &&
                    resObj.data.Obj &&
                    Array.isArray(resObj.data.Obj.List)
                ) {
                    setLoanApplications(resObj.data.Obj.List);
                    setTotalCount(resObj.data.Obj.TotalRecords || 0);
                    setLoading(false);
                } else {
                    message.error(resObj.data.Message || COMMON_ERROR_MSG)
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error fetching loan applications:", error);
                setLoading(false);
            }
        }
    };

    const currentMonthYear = _commonService.getCurrentMonthAndYear();

    const handleClearFilters = () => {
        setSearchTerm("");
        setFromDate(null);
        setToDate(null);
        setSortBy(null);
        setApplicationStatus(0);
        setPageIndex(1);
        setPageSize(10);
    };

    const handlePaginationChange = (page, size) => {
        setPageIndex(page);
        setPageSize(size);
    };

    const handleApplicationStatusChange = (value) => {
        setApplicationStatus(value);
        setPageIndex(1);
    };

    const handleFromDateChange = (value) => {
        setFromDate(value);
        setPageIndex(1);
    };

    const handleToDateChange = (value) => {
        setToDate(value);
        setPageIndex(1);
    };

    const handleSortChange = (value) => {
        setSortBy(value);
        setPageIndex(1);
    };

    return (
        <Spin spinning={loading}>
            <SidebarLayout>

                {/* <Title level={3}>All Applications</Title> */}
                {/* <Title className="mb10" level={5}>Monthly Review, {currentMonthYear}</Title> */}

                <div style={{ marginBottom: 24 }}>
                    <ApplicationList
                        allApplications={loanApplications}
                        loading={loading}
                        pageIndex={pageIndex}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        onPaginationChange={handlePaginationChange}
                        searchTerm={searchTerm}
                        fromDate={fromDate}
                        toDate={toDate}
                        sortBy={sortBy}
                        onSearchChange={setSearchTerm}
                        fromDateChange={handleFromDateChange}
                        toDateChange={handleToDateChange}
                        onSortChange={handleSortChange}
                        onClearFilters={handleClearFilters}
                        onApplicationStatusChange={handleApplicationStatusChange}
                        applicationStatusForFilter={applicationStatus}
                        isFromLoanOfficerDashboard={true}
                    />
                </div>
            </SidebarLayout>
        </Spin>
    );
};

export default LoanApplicationsForLoanOfficer;